import request from '@/utils/request'

let homePageApi = {
  /*分类*/
  getIndexData(data, errorback) {
    return request._get('/pc/index/index', data, errorback);
  },
   /*分类*/
   getDiyData(data, errorback) {
    return request._get('/pc/index/diy', data, errorback);
  },
  /*专区列表*/
  getlistData(data, errorback) {
    return request._get('/pc/index/page/list', data, errorback);
  }
}
export default homePageApi;


// WEBPACK FOOTER //
// ./src/api/diyPage.js